import script from "./CategorySection.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySection.vue?vue&type=script&setup=true&lang=js"

import "./CategorySection.vue?vue&type=style&index=0&id=70099828&lang=scss"

const __exports__ = script;

export default __exports__